import React, { useMemo } from "react";
import ReactMarkdown from "react-markdown";
import AIReactionModal from "./AIReactionModal";
import BaseServiceApi from "BaseServiceApi";
import UserInfoUtil from "UserInfoUtil";
import { AINewsType } from "../../Constants/AINewsConstants";

const EntitlementType = BaseServiceApi.rayData["EntitlementType"];

const AISummaryContent = ({ data, handleReaction, newsType }) => {
  const isAIFeedbackEntitled = UserInfoUtil.IsUserEntitled(
    EntitlementType.AI_FEEDBACK_Entitlement
  );
  function isDate(text) {
    if (typeof text !== "string") {
      return false;
    }
    const date = new Date(text);
    if (
      isNaN(date.getFullYear()) ||
      isNaN(date.getDay()) ||
      isNaN(date.getMonth())
    ) {
      return false;
    }
    return true;
  }

  const getParentText = (children) => {
    let text = extractText(children);
    return isDate(text) ? text : "";
  };

  function extractText(children) {
    let text = "";

    React.Children.forEach(children, (child) => {
      if (typeof child === "string") {
        text += child;
      } else if (React.isValidElement(child)) {
        text += extractText(child.props.children);
      }
    });

    return text.trim();
  }

  const memonizedContent = useMemo(() => {
    let lastParentText = "";
    const popoverElement = document.getElementById("ai-summary-popover") || document.getElementById("trackPriceAiNewsDiv");
    const popoverRect = popoverElement?.getBoundingClientRect();
    const innerOffset = Math.max(0, popoverRect ? 192.5 - (popoverRect.left + 27) : 0);
    const translateX = Math.max(0, 150 - innerOffset);
    return (
      <ReactMarkdown
        components={{
          p: ({ children }) => {
            lastParentText = getParentText(children);
            return <p>{children}</p>;
          },
          h1: ({ children }) => {
            lastParentText = getParentText(children);
            return <h1>{children}</h1>;
          },
          h2: ({ children }) => {
            lastParentText = getParentText(children);
            return <h2>{children}</h2>;
          },
          h3: ({ children }) => {
            lastParentText = getParentText(children);
            return <h3>{children}</h3>;
          },
          h4: ({ children }) => {
            lastParentText = getParentText(children);
            return <h4>{children}</h4>;
          },
          h5: ({ children }) => {
            lastParentText = getParentText(children);
            return <h5>{children}</h5>;
          },
          h6: ({ children }) => {
            lastParentText = getParentText(children);
            return <h6>{children}</h6>;
          },
          li: ({ children, ...props }) => {
            const text = extractText(children);
            return (
              <li
                {...props}
                id={`${props.index} ai-li`}
                style={{
                  listStyleType: isAIFeedbackEntitled ? "none" : "",
                  margin: "5px 0px",
                  display: isAIFeedbackEntitled ? "flex" : "",
                  gap: "5px",
                }}
              >
                {isAIFeedbackEntitled && (
                  <AIReactionModal
                    text={text}
                    handleReaction={(text, reaction, comments, date) =>
                      handleReaction(
                        `${date}${props.index}`,
                        text,
                        reaction,
                        comments,
                        date
                      )
                    }
                    parentText={lastParentText}
                    translateX={translateX}
                  />
                )}
                <p>{children}</p>
              </li>
            );
          },
          ul: ({ children, ...props }) => (
            <ul
              {...props}
              style={{ paddingLeft: isAIFeedbackEntitled ? "5px" : "20px" }}
            >
              {children}
            </ul>
          ),
          a: ({ href, children, ...props }) => (
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              {...props}
            >
              {children}
            </a>
          ),
        }}
      >
        {data}
      </ReactMarkdown>
    );
  }, [data]);

  return <div className="space-y-4">{memonizedContent}</div>;
};

export default AISummaryContent;
